import { Routes } from '@angular/router';
import { AuthGuard } from '@auth0/auth0-angular';

import { reportsAccessGuard } from './guards/reports-access.guard';
import { uploadAccessGuard } from './guards/upload-access.guard';

export const routes: Routes = [
  {
    path: '',
    pathMatch: 'full',
    loadComponent: () => import('./pages/files/files.page').then((m) => m.FilesPageComponent),
    canActivate: [AuthGuard],
  },
  {
    path: 'reports',
    loadComponent: () =>
      import('./pages/reports/reports-list.page').then((m) => m.ReportsListPageComponent),
    canActivate: [AuthGuard, reportsAccessGuard],
  },
  {
    path: 'reports/:slug',
    loadComponent: () =>
      import('./pages/reports/run-report.page').then((m) => m.RunReportPageComponent),
    canActivate: [AuthGuard, reportsAccessGuard],
  },
  {
    path: 'upload',
    loadComponent: () => import('./pages/upload/upload.page').then((m) => m.UploadPageComponent),
    canActivate: [AuthGuard, uploadAccessGuard],
  },
  {
    path: 'access-denied',
    loadComponent: () =>
      import('./pages/access-denied/access-denied.component').then((m) => m.AccessDeniedComponent),
  },
  { path: '**', redirectTo: '' },
];
